import { pathBuilder } from 'config/paths/index';

export const root = '/admin/roles';
export default pathBuilder(root);
